import ExecuteApiCall from './apiClient';

export function fetchAllMedications() {
  return ExecuteApiCall('get', 'api/v2/reference/medications');
}
